<template>
  <div class="wrapper">
    <div class="wrapper__box">
      <div class="wrapper__content">
        <BaseIcon
          glyph="chevron-left"
          class="wrapper__slide-button"
          :class="{ disabled: currentSlideIndex === 0 }"
          @click="prevSlide"
        />
        <div class="carousel-wrapper">
          <div class="carousel">
            <div
              v-for="(item, index) in carouselData"
              :key="item.id"
              class="carousel__item"
              :class="{ active: index === currentSlideIndex }"
            >
              <slot name="carousel-data" :carouselData="item"></slot>
            </div>
          </div>
        </div>
        <BaseIcon
          glyph="chevron-right"
          class="wrapper__slide-button"
          :class="{ disabled: currentSlideIndex >= carouselData.length - 1 }"
          @click="nextSlide"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Carousel",
  components: {},
  props: {
    carouselData: {},
    selectedData: {},
  },
  data() {
    return {
      currentSlideIndex: 0,
    };
  },
  watch: {
    selectedData(val) {
      this.currentSlideIndex = this.carouselData.findIndex((item) => {
        return item.id === val;
      });
    },
  },
  methods: {
    prevSlide() {
      if (this.currentSlideIndex > 0) {
        this.currentSlideIndex--;
        this.$emit("changeSlide", this.carouselData[this.currentSlideIndex]);
      }
    },
    nextSlide() {
      if (this.currentSlideIndex < this.carouselData.length - 1) {
        this.currentSlideIndex++;
        this.$emit("changeSlide", this.carouselData[this.currentSlideIndex]);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  background-color: #fff;
  min-height: 100%;
  border-radius: @border-radius-xs;

  &__content {
    width: 100%;
    display: flex;
    justify-content: space-between;
    height: 100%;
  }

  &__slide-button {
    width: 45px;
    height: 90px;
    color: @primary-color;
    align-self: center;
    cursor: pointer;

    @media screen and (max-width: @screen-xs) {
      margin-top: 0;
    }

    &.disabled {
      color: @dark-gray-color;
      cursor: auto;
    }
  }

  &__box {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
}

.carousel {
  display: flex;
  width: 100%;
  min-height: 100%;

  &-wrapper {
    position: relative;
    background-color: #fff;
    width: 100%;
    min-height: 100%;
  }

  &__item {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    min-width: 100%;
    opacity: 0;
    transition: opacity 0.3s;

    &.active {
      opacity: 1;
      z-index: 1;
    }
  }
}
</style>
